<template>
  <div>
    <header class="header">
      <div class="header-middle sticky-header color_header">
        <div class="container">
          <div class="header-left">
            <button class="mobile-menu-toggler">
              <span class="sr-only">Toggle mobile menu</span>
              <i class="icon-bars"></i>
            </button>

            <a href="/" class="logo color-text">
              <img src="/static/images/logo.svg" alt="LSG Stock" />
            </a>

            <nav class="main-nav">
              <ul class="menu sf-arrows" v-if="links.length">
                <router-link
                  v-for="(link, idx) in links"
                  :id="`menu-${idx}`"
                  :key="`mobile-menu-${idx}`"
                  tag="li"
                  :class="{
                    active: $route.path === link.active,
                  }"
                  :to="{ name: link.component, query: link.query }"
                >
                  <a
                    :class="{
                      'sf-with-ul': link.children.length,
                    }"
                    >{{ link.text }}
                  </a>
                  <ul v-if="link.children.length">
                    <li
                      v-for="(submenu, i) in link.children"
                      :key="`submenu-${i}`"
                    >
                      <a
                        v-if="submenu.Type == 'external'"
                        :href="submenu.Href"
                        target="_blank"
                        >{{ submenu.Text }}</a
                      >
                      <router-link
                        v-else
                        :to="{
                          name: 'List',
                          query: {
                            collection: submenu.Collection,
                            range: submenu.Name,
                          },
                        }"
                        >{{ submenu.Name }}</router-link
                      >
                    </li>
                  </ul>
                </router-link>
                <li>
                  <a
                    target="blank"
                    href="https://lifestylegardenbrand.scancom.net/"
                  >
                    Brand Portal
                  </a>
                </li>
                <li v-if="specialOffer">
                  <router-link
                    :to="{
                      name: 'List',
                      query: {
                        specialOffer: true,
                      },
                    }"
                  >
                    LIMITED EDITION
                  </router-link>
                </li>
              </ul>
            </nav>
          </div>

          <div class="header-right">
            <SearchBox />
            <div class="dropdown cart-dropdown">
              <router-link
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-display="static"
                role="button"
                :to="{
                  name: 'MyCollection',
                }"
              >
                <i class="icon-shopping-cart color-text"></i>
                <span class="cart-count" v-if="authUser && collection.length">{{
                  collection.length
                }}</span>
                <span class="cart-count" v-else>0</span>
              </router-link>
            </div>
            <div class="header-right">
              <nav class="main-nav">
                <ul class="menu sf-arrows">
                  <li v-if="authUser">
                    <a href="javascript:" class="sf-with-ul color-text no-wrap">
                      <i class="icon-user color-text"></i>Hi,
                      {{ authUser.firstName ? authUser.firstName : "User" }}
                    </a>
                    <ul>
                      <li>
                        <a href="javascript:"
                          ><strong>{{ authUser.fullName }}</strong></a
                        >
                      </li>
                      <router-link
                        v-if="checkIsAdmin"
                        tag="li"
                        :to="{
                          name: 'Admin',
                        }"
                      >
                        <a>
                          <i class="icon-jira"></i>
                          Admin page</a
                        >
                      </router-link>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'SavedCollections',
                        }"
                      >
                        <a>
                          <i class="icon-jira"></i>
                          Saved collection</a
                        >
                      </router-link>
                      <router-link
                        tag="li"
                        :to="{
                          name: 'ChangePassword',
                        }"
                      >
                        <a>
                          <i class="icon-jira"></i>
                          Change password</a
                        >
                      </router-link>
                      <li>
                        <a href="javascript:" @click="logout"
                          ><i class="icon-jira"></i> Sign out</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li v-else>
                    <a
                      href="javascript:"
                      @click="login()"
                      :class="{
                        'sf-with-ul': authUser,
                      }"
                    >
                      <i class="icon-user"></i>Login
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div class="mobile-menu-overlay"></div>
        <!-- End .mobil-menu-overlay -->
        <aside class="mobile-menu-container mobile-menu-dark">
          <div class="mobile-menu-wrapper">
            <span class="mobile-menu-close"><i class="icon-close"></i></span>
            <ul class="mobile-menu">
              <li v-if="authUser && authUser.fullName">
                <a href="javascript:"
                  ><strong>{{ authUser.fullName }}</strong></a
                >
              </li>
              <li v-else>
                <a href="/login"> <i class="icon-user"></i>Login </a>
              </li>
            </ul>

            <form action="#" method="get" class="mobile-search">
              <label for="mobile-search" class="sr-only">Search</label>
              <input
                type="search"
                class="form-control"
                name="mobile-search"
                id="mobile-search"
                placeholder="Search in..."
                required
                v-model="searchText"
                @focus="showDropdown = true"
              />
              <button
                class="btn btn-primary"
                type="button"
                @click="btnSearchProduct"
              >
                <i class="icon-search"></i>
              </button>
            </form>

            <nav class="mobile-nav">
              <ul class="mobile-menu">
                <router-link
                  v-for="(link, idx) in links"
                  :key="`mobile-menu-${idx}`"
                  tag="li"
                  :class="{
                    active: $route.path === link.active,
                  }"
                  :to="{
                    name: link.component,
                    query: link.query,
                  }"
                >
                  <a
                    :class="{
                      'sf-with-ul': link.children.length,
                    }"
                    >{{ link.text }}
                  </a>
                  <ul v-if="link.children.length">
                    <li
                      v-for="(submenu, i) in link.children"
                      :key="`submenu-${i}`"
                    >
                      <a
                        v-if="submenu.Type == 'external'"
                        :href="submenu.Href"
                        target="_blank"
                        >{{ submenu.Text }}</a
                      >
                      <router-link
                        v-else
                        :to="{
                          name: 'List',
                          query: {
                            collection: submenu.Collection,
                            range: submenu.Name,
                          },
                        }"
                        >{{ submenu.Name }}</router-link
                      >
                    </li>
                  </ul>
                </router-link>
                <li>
                  <a
                    target="blank"
                    href="https://lifestylegardenbrand.scancom.net/"
                    >Brand Portal</a
                  >
                </li>
                <li v-if="specialOffer">
                  <router-link
                    :to="{
                      name: 'List',
                      query: {
                        specialOffer: true,
                      },
                    }"
                  >
                    LIMITED EDITION
                  </router-link>
                </li>
                <router-link
                  tag="li"
                  :to="{
                    name: 'ChangePassword',
                  }"
                >
                  <a>
                    <i class="icon-jira"></i>
                    Change password</a
                  >
                </router-link>
                <router-link
                  tag="li"
                  :to="{
                    name: 'SavedCollections',
                  }"
                >
                  <a>
                    <i class="icon-jira"></i>
                    Saved collection</a
                  >
                </router-link>
                <li v-if="authUser && authUser.fullName">
                  <a href="javascript:" @click="logout"
                    ><i class="icon-jira"></i> Sign out</a
                  >
                </li>
              </ul>
            </nav>
          </div>
        </aside>
      </div>
    </header>
  </div>
</template>

<script>
import SearchBox from "../components/SearchBox.vue";

export default {
  name: "TheHeader",
  components: {
    SearchBox,
  },
  data() {
    return {
      searchText: null,
      links: [],
      specialOffer: true,
    };
  },
  computed: {
    currentName() {
      return this.$route.name;
    },
    authUser() {
      return this.$user.getters.authUser;
    },
    async checkIsAdmin() {
      if (this.$user.getters.authUser) {
        let resp = await this.$http.get("/api/auth/role");
        return resp.data && resp.data.includes("admin");
      }
      return false;
    },
    collection() {
      return this.$collection.getters.collection;
    },
  },
  async mounted() {
    let rangesMenu = await this.loadRangesMenu("COLLECTIONS");
    let teakRangesMenu = await this.loadRangesMenu("TEAK COLLECTIONS");
    this.links = [
      {
        component: "HomePage",
        text: "Home",
        active: "/",
        type: "link",
        children: [],
      },
      {
        component: "List",
        text: "COLLECTIONS",
        active: "list",
        children: rangesMenu,
      },
      {
        component: "List",
        text: "TEAK COLLECTIONS",
        active: `list?collection=TEAK COLLECTIONS`,
        query: { collection: "TEAK COLLECTIONS" },
        children: teakRangesMenu,
      },
      {
        component: "HomePage",
        text: "E-Catalogues",
        active: "e-catalogues",
        children: [
          {
            Text: "Collection 2025",
            Type: "external",
            Href: "https://catalogue.lifestylegarden.com/lifestylegarden-catalogue-2025/",
          },
          {
            Text: "Teak Collection 2025",
            Type: "external",
            Href: "https://catalogue.lifestylegarden.com/teak-catalogue/",
          },
        ],
      },
      // {
      //   component: "Contact",
      //   text: "Contact",
      //   active: "contact",
      //   type: "link",
      //   children: []
      // }
    ];
    await this.loadMainJs();
    window.addEventListener("resize", this.loadMainJs);
  },
  methods: {
    btnSearchProduct() {
      if (this.searchText) {
        this.$router
          .push({
            name: "List",
            query: {
              keywords: this.searchText,
            },
          })
          .catch(() => {});
      }
    },
    login() {
      this.$router.push({ name: "Login" });
    },
    logout() {
      this.$user.dispatch("logout").then(() => {
        let returnUrl = this.$router.currentRoute.fullPath;
        let query = returnUrl ? { returnUrl } : null;
        this.$router.push({ name: "Login", query });
      });
    },
    async loadRangesMenu(collection) {
      let result = [];
      try {
        let params = {
          $apply: `filter(${[
            `Status eq ${this.$const.STATUS.Active}`,
            "DrawingCode ne null",
            `CollectionName eq '${collection}'`,
          ].join(" and ")})/groupby((RangeName))`,
        };
        let resp = await this.$http.get("/odata/LsgProductNew", {
          params,
        });

        if (resp && resp.status == 200 && resp.data.length) {
          result = resp.data.map((_) => {
            return {
              Name: _.RangeName,
              Collection: collection,
            };
          });
        }
      } catch (error) {
        console.log(error);
      }
      return result;
    },
    closeMobileMenu() {
      let $ = window.jQuery,
        $body = $("body");
      $body.removeClass("mmenu-active");
      $(".menu-toggler").removeClass("active");
    },
    async loadMainJs() {
      let $ = window.jQuery;
      // Main Js File
      $(document).ready(function () {
        "use strict";

        owlCarousels();
        quantityInputs();

        // Header Search Toggle

        var $searchWrapper = $(".header-search-wrapper"),
          $body = $("body"),
          $searchToggle = $(".search-toggle");

        $searchToggle.on("click", function (e) {
          $searchWrapper.toggleClass("show");
          $(this).toggleClass("active");
          $searchWrapper.find("input").focus();
          e.preventDefault();
        });

        $body.on("click", function (e) {
          if ($searchWrapper.hasClass("show")) {
            $searchWrapper.removeClass("show");
            $searchToggle.removeClass("active");
            $body.removeClass("is-search-active");
          }
        });

        $(".header-search").on("click", function (e) {
          e.stopPropagation();
        });

        // Sticky header
        var catDropdown = $(".category-dropdown"),
          catInitVal = catDropdown.data("visible");

        if ($(".sticky-header").length && $(window).width() >= 360) {
          var sticky = new Waypoint.Sticky({
            element: $(".sticky-header")[0],
            stuckClass: "fixed",
            offset: -300,
            handler: function (direction) {
              // Show category dropdown
              if ((catInitVal && direction == "up") || direction == "down") {
                catDropdown
                  .addClass("show")
                  .find(".dropdown-menu")
                  .addClass("show");
                catDropdown
                  .find(".dropdown-toggle")
                  .attr("aria-expanded", "true");
                return false;
              }

              // Hide category dropdown on fixed header
              if (catDropdown.hasClass("show")) {
                catDropdown
                  .removeClass("show")
                  .find(".dropdown-menu")
                  .removeClass("show");
                catDropdown
                  .find(".dropdown-toggle")
                  .attr("aria-expanded", "false");
              }
            },
          });
        }

        // Mobile Menu Toggle - Show & Hide
        $(".mobile-menu-toggler").on("click", function (e) {
          $body.toggleClass("mmenu-active");
          $(this).toggleClass("active");
          e.preventDefault();
        });

        $(".mobile-menu-overlay, .mobile-menu-close").on("click", function (e) {
          $body.removeClass("mmenu-active");
          $(".menu-toggler").removeClass("active");
          e.preventDefault();
        });

        // Add Mobile menu icon arrows to items with children
        $(".mobile-menu")
          .find("li")
          .each(function () {
            var $this = $(this);

            if ($this.find("ul").length) {
              $("<span/>", {
                class: "mmenu-btn",
              }).appendTo($this.children("a"));
            }
          });

        // Mobile Menu toggle children menu
        $(".mmenu-btn").on("click", function (e) {
          var $parent = $(this).closest("li"),
            $targetUl = $parent.find("ul").eq(0);

          if (!$parent.hasClass("open")) {
            $targetUl.slideDown(300, function () {
              $parent.addClass("open");
            });
          } else {
            $targetUl.slideUp(300, function () {
              $parent.removeClass("open");
            });
          }

          e.stopPropagation();
          e.preventDefault();
        });

        // Sidebar Filter - Show & Hide
        var $sidebarToggler = $(".sidebar-toggler");
        $sidebarToggler.on("click", function (e) {
          $body.toggleClass("sidebar-filter-active");
          $(this).toggleClass("active");
          e.preventDefault();
        });

        $(".sidebar-filter-overlay").on("click", function (e) {
          $body.removeClass("sidebar-filter-active");
          $sidebarToggler.removeClass("active");
          e.preventDefault();
        });

        // Clear All checkbox/remove filters in sidebar filter
        $(".sidebar-filter-clear").on("click", function (e) {
          $(".sidebar-shop").find("input").prop("checked", false);

          e.preventDefault();
        });

        // Popup - Iframe Video - Map etc.
        if ($.fn.magnificPopup) {
          $(".btn-iframe").magnificPopup({
            type: "iframe",
            removalDelay: 600,
            preloader: false,
            fixedContentPos: false,
            closeBtnInside: false,
          });
        }

        // Product hover
        if ($.fn.hoverIntent) {
          $(".product-3").hoverIntent(
            function () {
              var $this = $(this),
                animDiff =
                  $this.outerHeight() -
                  ($this.find(".product-body").outerHeight() +
                    $this.find(".product-media").outerHeight()),
                animDistance =
                  $this.find(".product-footer").outerHeight() - animDiff;

              $this
                .find(".product-footer")
                .css({ visibility: "visible", transform: "translateY(0)" });
              $this
                .find(".product-body")
                .css("transform", "translateY(" + -animDistance + "px)");
            },
            function () {
              var $this = $(this);

              $this
                .find(".product-footer")
                .css({ visibility: "hidden", transform: "translateY(100%)" });
              $this.find(".product-body").css("transform", "translateY(0)");
            }
          );
        }

        // Quantity Input - Cart page - Product Details pages
        function quantityInputs() {
          if ($.fn.inputSpinner) {
            $("input[type='number']").inputSpinner({
              decrementButton: '<i class="icon-minus"></i>',
              incrementButton: '<i class="icon-plus"></i>',
              groupClass: "input-spinner",
              buttonsClass: "btn-spinner",
              buttonsWidth: "26px",
            });
          }
        }

        // Sticky Content - Sidebar - Social Icons etc..
        // Wrap elements with <div class="sticky-content"></div> if you want to make it sticky
        if ($.fn.stick_in_parent && $(window).width() >= 992) {
          $(".sticky-content").stick_in_parent({
            offset_top: 80,
            inner_scrolling: false,
          });
        }

        function owlCarousels($wrap, options) {
          if ($.fn.owlCarousel) {
            var owlSettings = {
              items: 1,
              loop: true,
              margin: 0,
              responsiveClass: true,
              nav: true,
              navText: [
                '<i class="icon-angle-left">',
                '<i class="icon-angle-right">',
              ],
              dots: true,
              smartSpeed: 400,
              autoplay: false,
              autoplayTimeout: 15000,
            };
            if (typeof $wrap == "undefined") {
              $wrap = $("body");
            }
            if (options) {
              owlSettings = $.extend({}, owlSettings, options);
            }

            // Init all carousel
            $wrap.find('[data-toggle="owl"]').each(function () {
              var $this = $(this),
                newOwlSettings = $.extend(
                  {},
                  owlSettings,
                  $this.data("owl-options")
                );

              $this.owlCarousel(newOwlSettings);

              $("body").addClass("loaded");
            });
          }
        }

        // Product Image Zoom plugin - product pages
        if ($.fn.elevateZoom) {
          $("#product-zoom").elevateZoom({
            gallery: "product-zoom-gallery",
            galleryActiveClass: "active",
            zoomType: "inner",
            cursor: "crosshair",
            zoomWindowFadeIn: 400,
            zoomWindowFadeOut: 400,
            responsive: true,
          });

          // On click change thumbs active item
          $(".product-gallery-item").on("click", function (e) {
            $("#product-zoom-gallery").find("a").removeClass("active");
            $(this).addClass("active");

            e.preventDefault();
          });

          var ez = $("#product-zoom").data("elevateZoom");

          // Open popup - product images
          $("#btn-product-gallery").on("click", function (e) {
            if ($.fn.magnificPopup) {
              $.magnificPopup.open(
                {
                  items: ez.getGalleryList(),
                  type: "image",
                  gallery: {
                    enabled: true,
                  },
                  fixedContentPos: false,
                  removalDelay: 600,
                  closeBtnInside: false,
                },
                0
              );

              e.preventDefault();
            }
          });
        }

        // Product Gallery - product-gallery.html
        if ($.fn.owlCarousel && $.fn.elevateZoom) {
          var owlProductGallery = $(".product-gallery-carousel");

          owlProductGallery.on("initialized.owl.carousel", function () {
            owlProductGallery.find(".active img").elevateZoom({
              zoomType: "inner",
              cursor: "crosshair",
              zoomWindowFadeIn: 400,
              zoomWindowFadeOut: 400,
              responsive: true,
            });
          });

          owlProductGallery.owlCarousel({
            loop: false,
            margin: 0,
            responsiveClass: true,
            nav: true,
            navText: [
              '<i class="icon-angle-left">',
              '<i class="icon-angle-right">',
            ],
            dots: false,
            smartSpeed: 400,
            autoplay: false,
            autoplayTimeout: 15000,
            responsive: {
              0: {
                items: 1,
              },
              560: {
                items: 2,
              },
              992: {
                items: 3,
              },
              1200: {
                items: 3,
              },
            },
          });

          owlProductGallery.on("change.owl.carousel", function () {
            $(".zoomContainer").remove();
          });

          owlProductGallery.on("translated.owl.carousel", function () {
            owlProductGallery.find(".active img").elevateZoom({
              zoomType: "inner",
              cursor: "crosshair",
              zoomWindowFadeIn: 400,
              zoomWindowFadeOut: 400,
              responsive: true,
            });
          });
        }

        // Product Gallery Separeted- product-sticky.html
        if ($.fn.elevateZoom) {
          $(".product-separated-item").find("img").elevateZoom({
            zoomType: "inner",
            cursor: "crosshair",
            zoomWindowFadeIn: 400,
            zoomWindowFadeOut: 400,
            responsive: true,
          });

          // Create Array for gallery popup
          var galleryArr = [];
          $(".product-gallery-separated")
            .find("img")
            .each(function () {
              var $this = $(this),
                imgSrc = $this.attr("src"),
                imgTitle = $this.attr("alt"),
                obj = { src: imgSrc, title: imgTitle };

              galleryArr.push(obj);
            });

          $("#btn-separated-gallery").on("click", function (e) {
            if ($.fn.magnificPopup) {
              $.magnificPopup.open(
                {
                  items: galleryArr,
                  type: "image",
                  gallery: {
                    enabled: true,
                  },
                  fixedContentPos: false,
                  removalDelay: 600,
                  closeBtnInside: false,
                },
                0
              );

              e.preventDefault();
            }
          });
        }

        // Dashboard Page Tab Trigger
        $(".tab-trigger-link").on("click", function (e) {
          var targetHref = $(this).attr("href");

          $(".nav-dashboard")
            .find('a[href="' + targetHref + '"]')
            .trigger("click");

          e.preventDefault();
        });

        // Scroll To button
        var $scrollTo = $(".scroll-to");
        // If button scroll elements exists
        if ($scrollTo.length) {
          // Scroll to - Animate scroll
          $scrollTo.on("click", function (e) {
            var target = $(this).attr("href"),
              $target = $(target);
            if ($target.length) {
              // Add offset for sticky menu
              var scrolloffset =
                $(window).width() >= 992
                  ? $target.offset().top - 52
                  : $target.offset().top;
              $("html, body").animate(
                {
                  scrollTop: scrolloffset,
                },
                600
              );
              e.preventDefault();
            }
          });
        }

        // Scroll Top Button - Show
        var $scrollTop = $("#scroll-top");

        $(window).on("load scroll", function () {
          if ($(window).scrollTop() >= 400) {
            $scrollTop.addClass("show");
          } else {
            $scrollTop.removeClass("show");
          }
        });

        // On click animate to top
        $scrollTop.on("click", function (e) {
          $("html, body").animate(
            {
              scrollTop: 0,
            },
            800
          );
          e.preventDefault();
        });

        // Product quickView popup
        $(".btn-quickview").on("click", function (e) {
          var ajaxUrl = $(this).attr("href");
          if ($.fn.magnificPopup) {
            setTimeout(function () {
              $.magnificPopup.open(
                {
                  type: "ajax",
                  mainClass: "mfp-ajax-product",
                  tLoading: "",
                  preloader: false,
                  removalDelay: 350,
                  items: {
                    src: ajaxUrl,
                  },
                  callbacks: {
                    ajaxContentAdded: function () {
                      owlCarousels($(".quickView-content"), {
                        onTranslate: function (e) {
                          var $this = $(e.target),
                            currentIndex =
                              ($this.data("owl.carousel").current() +
                                e.item.count -
                                Math.ceil(e.item.count / 2)) %
                              e.item.count;
                          $(".quickView-content .carousel-dot")
                            .eq(currentIndex)
                            .addClass("active")
                            .siblings()
                            .removeClass("active");
                        },
                      });
                      quantityInputs();
                    },
                    open: function () {
                      $("body").css("overflow-x", "visible");
                      $(".sticky-header.fixed").css("padding-right", "1.7rem");
                    },
                    close: function () {
                      $("body").css("overflow-x", "hidden");
                      $(".sticky-header.fixed").css("padding-right", "0");
                    },
                  },

                  ajax: {
                    tError: "",
                  },
                },
                0
              );
            }, 500);

            e.preventDefault();
          }
        });

        $("body").on("click", ".carousel-dot", function () {
          $(this).siblings().removeClass("active");
          $(this).addClass("active");
        });

        $("body").on("click", ".btn-fullscreen", function (e) {
          var galleryArr = [];
          $(this)
            .parents(".owl-stage-outer")
            .find(".owl-item:not(.cloned)")
            .each(function () {
              var $this = $(this).find("img"),
                imgSrc = $this.attr("src"),
                imgTitle = $this.attr("alt"),
                obj = { src: imgSrc, title: imgTitle };
              galleryArr.push(obj);
            });

          var ajaxUrl = $(this).attr("href");

          var mpInstance = $.magnificPopup.instance;
          if (mpInstance.isOpen) mpInstance.close();

          setTimeout(function () {
            $.magnificPopup.open(
              {
                type: "ajax",
                mainClass: "mfp-ajax-product",
                tLoading: "",
                preloader: false,
                removalDelay: 350,
                items: {
                  src: ajaxUrl,
                },
                callbacks: {
                  ajaxContentAdded: function () {
                    owlCarousels($(".quickView-content"), {
                      onTranslate: function (e) {
                        var $this = $(e.target),
                          currentIndex =
                            ($this.data("owl.carousel").current() +
                              e.item.count -
                              Math.ceil(e.item.count / 2)) %
                            e.item.count;
                        $(".quickView-content .carousel-dot")
                          .eq(currentIndex)
                          .addClass("active")
                          .siblings()
                          .removeClass("active");
                        $(".curidx").html(currentIndex + 1);
                      },
                    });
                    quantityInputs();
                  },
                  open: function () {
                    $("body").css("overflow-x", "visible");
                    $(".sticky-header.fixed").css("padding-right", "1.7rem");
                  },
                  close: function () {
                    $("body").css("overflow-x", "hidden");
                    $(".sticky-header.fixed").css("padding-right", "0");
                  },
                },

                ajax: {
                  tError: "",
                },
              },
              0
            );
          }, 500);

          e.preventDefault();
        });
      });
    },
  },
};
</script>
<style>
.logo img {
  width: 24vh !important;
  height: 75px;
}

.fixed .logo img {
  width: 24vh !important;
  height: 55px;
}

@media screen and (min-width: 400px) {
  .logo img {
    width: 24vh !important;
  }
}

@media screen and (min-width: 800px) {
}

@media screen and (min-width: 1120px) {
  .logo img {
    width: 20vh !important;
  }
}

@media screen and (max-width: 1080px) {
  .action {
    margin-top: -75px;
  }

  .logo img {
    width: 16vh !important;
  }

  #menu-3,
  #menu-2 {
    display: none;
  }

  .col-pd1 .content h3 {
    font-size: 2.4rem;
  }
}

.mobile-menu-container {
  overflow-y: hidden !important;
  float: none !important;
  z-index: 1038;
}
</style>



// WEBPACK FOOTER //
// src/components/TheHeader.vue